import { useLang } from 'hooks/lang';

import { Row, Link, Skeleton } from 'components/Blocks';

import { loaders, projectInvoiceStatusConfig } from 'entities';
import { AlarmIcon } from 'components/Icons';

import { IconBox } from './IconBox';
import { NumCount } from './NumCount';

function ReadyToCreate(): JSX.Element {
  const { t } = useLang();

  const { data, errorOrLoading } = loaders.invoice.projectInvoiceCounts.use({
    defaultValue: {},

    realTimeSubscription: {
      type: 'PROJECT_INVOICE_COUNTS',

      onMessage: ({ counts }) => counts,
    },
  });

  const config = projectInvoiceStatusConfig.readyToInvoice;

  if (errorOrLoading) return <Skeleton height={130} />;

  return (
    <Link
      className="flex h-[130px] flex-col justify-center gap-4 rounded-md border border-border p-4 transition-colors hover:bg-hover"
      to="invoices"
      params={{ status: 'pre-creation' }}
    >
      <Row className="single" justifyContent="space-between" gap="2">
        <p className="font-medium ">{config.getLabel(t)}</p>

        <IconBox>
          <AlarmIcon className="yellow" />
        </IconBox>
      </Row>

      <NumCount count={data[config.code] ?? 0} />
    </Link>
  );
}

export default ReadyToCreate;
